/* Wish Dance — galleria filtrata per colore sui prodotti con opzione "Colore".
   Le foto sono associate al colore tramite l'alt text del media: se l'alt contiene
   il valore esatto dell'opzione Colore (en-dash incluso), la foto appartiene a quel
   colore; le foto senza colore nell'alt restano sempre visibili.
   In più: barra le taglie senza stock nel colore selezionato (classe wd-size-out).
   Dawn disabilita una taglia solo se esaurita in TUTTI i colori; qui incrociamo
   taglia×colore leggendo le varianti da /products/<handle>.js. Le taglie barrate
   restano cliccabili per non intrappolare l'utente. */
(function () {
  'use strict';
  if (window.__wdColorGallerySetup) return;
  window.__wdColorGallerySetup = true;

  function colorInputs() {
    var out = [];
    document.querySelectorAll('variant-selects fieldset.product-form__input').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      if (legend.textContent.trim().toLowerCase().indexOf('colore') !== 0) return;
      fs.querySelectorAll('input[type="radio"]').forEach(function (i) {
        out.push(i);
      });
    });
    return out;
  }

  function itemAlt(el) {
    var img = el.querySelector('img');
    return (img && img.getAttribute('alt')) || '';
  }

  var productData = null;
  var productDataFailed = false;
  function loadProductData() {
    if (productData || productDataFailed) return;
    var m = location.pathname.match(/\/products\/[a-z0-9-]+/);
    if (!m) {
      productDataFailed = true;
      return;
    }
    fetch(m[0] + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        productData = p;
        apply();
      })
      .catch(function () {
        productDataFailed = true;
      });
  }

  function optionIndex(name) {
    var target = String(name).trim().toLowerCase();
    for (var i = 0; i < (productData.options || []).length; i++) {
      var o = productData.options[i];
      var n = typeof o === 'string' ? o : o.name;
      if (String(n).trim().toLowerCase() === target) return i;
    }
    return -1;
  }

  function syncSizes(selectedColor, colorOptionName) {
    if (!productData) return;
    var colorIdx = optionIndex(colorOptionName);
    if (colorIdx === -1) return;
    document
      .querySelectorAll('variant-selects fieldset.product-form__input input[type="radio"]')
      .forEach(function (input) {
        var optName = input.getAttribute('data-option-name');
        if (!optName || optName === colorOptionName) return;
        var idx = optionIndex(optName);
        if (idx === -1) return;
        var variant = (productData.variants || []).filter(function (v) {
          return (
            v['option' + (idx + 1)] === input.value &&
            v['option' + (colorIdx + 1)] === selectedColor
          );
        })[0];
        var out = !variant || !variant.available;
        input.classList.toggle('wd-size-out', out);
      });
  }

  function apply() {
    var inputs = colorInputs();
    if (!inputs.length) return;
    loadProductData();
    var colors = inputs.map(function (i) {
      return i.value;
    });
    var checked = inputs.filter(function (i) {
      return i.checked;
    })[0];
    if (!checked) return;
    var selected = checked.value;

    document
      .querySelectorAll('.product__media-item, .thumbnail-list__item')
      .forEach(function (el) {
        var alt = itemAlt(el);
        var hasColor = colors.some(function (c) {
          return c && alt.indexOf(c) !== -1;
        });
        el.style.display = !hasColor || alt.indexOf(selected) !== -1 ? '' : 'none';
      });

    syncSizes(selected, checked.getAttribute('data-option-name') || 'Colore');
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      setTimeout(apply, 150);
    }
  });

  /* Dawn ri-renderizza picker e galleria via fetch dopo il cambio variante:
     riapplica il filtro quando il DOM del prodotto cambia. */
  var scheduled = null;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = setTimeout(function () {
      scheduled = null;
      apply();
    }, 100);
  });

  function start() {
    apply();
    var info = document.querySelector('product-info, section.section-main-product, main');
    if (info) observer.observe(info, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
